import {lazy} from '@aboutyou/lazy-imports';
import React from 'react';
import {BrandShopPageSkeleton} from './BrandShopPageSkeleton';

export const BrandShopPage = lazy(
  () =>
    import('./BrandShopPage.eager').then(mod => ({default: mod.BrandShopPage})),
  {
    fallback: <BrandShopPageSkeleton />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
